<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title is-centered">Share with tutors</p>
    </header>
    <div v-if="loadingTutors" class="card-content">
      <p>Loading...</p>
    </div>
    <div v-else class="card-content">
      <b-table
        :show-header="false"
        v-if="tutors.length"
        :data="tutors"
        :mobile-cards="false"
        class="has-text-left"
      >
        <b-table-column field="email" label="" v-slot="props">
          {{ props.row.email }}
        </b-table-column>
        <b-table-column field="actions" label="" v-slot="props">
          <b-button
            v-if="canShare(props.row.tutorGuid)"
            type="is-info"
            size="is-small"
            @click="shareClick(props.row.tutorGuid)"
            :loading="sharing[props.row.tutorGuid]"
          >
            Share
          </b-button>
          <span v-else class="is-size-7 has-text-grey">Shared</span>
        </b-table-column>
      </b-table>
      <p v-else class="has-text-grey">
        You are not connected to any tutors. You can connect to a tutor using
        their tutor code from the
        <router-link to="/tutors">Tutors page</router-link>.
      </p>
    </div>
  </div>
</template>

<script>
import dataService from "../services/dataService";
import { mapActions } from "vuex";
export default {
  props: ["sectionId", "recordingGuid", "tutorLinks"],
  data() {
    return {
      tutors: [],
      sharing: {}, // per tutor guid
      loadingTutors: false
    };
  },
  methods: {
    ...mapActions(["shareRecordingWithTutor"]),
    async shareClick(tutorGuid) {
      this.$set(this.sharing, tutorGuid, true);
      await this.shareRecordingWithTutor({
        sectionId: this.sectionId,
        recordingGuid: this.recordingGuid,
        tutorGuid
      });
      this.$set(this.sharing, tutorGuid, false);
    },
    canShare(tutorGuid) {
      return !this.tutorLinks.find(tl => tl.tutor.tutorGuid === tutorGuid);
    },
    async fetchTutors() {
      this.loadingTutors = true;
      this.tutors = await dataService.getTutors();
      this.loadingTutors = false;
    }
  },
  async created() {
    await this.fetchTutors();
  }
};
</script>

<style lang="scss" scoped></style>
